import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import Modal from 'styled-react-modal';
import UpcomingVisitLabs, { CardMain, CardWrap, DetailsWrap } from './UpcomingVisitLabs';
import Articles from '../../landing/Articles';
import { APPOINTMENTS_NUTRITIONIST, GET_GI_MEMBERSHIP_SUMMARY } from '../../../graphql';
import withSession from '../../../lib/withSession';
import moment from 'moment';
import momentTz from 'moment-timezone';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';
import Paymentinformation from '../../../static/Paymentinformation.png';
import fullscriptIcon from '../../../static/fullscriptIcon.png';

import { isAsyncAppointment } from '../../../utils/appointments';
import ServicesAvailable from './ServicesAvailable';
import PastNutritionistVisits from './PastNutritionistVisits';
import ToDo from './ToDo';

const BoxRight = styled(Flex)`
  width: 274px;
  justify-content: flex-end;

  @media screen and (max-width: 1300px) {
    display: none;
  }
`;
const BoxRightMobile = styled(Box)`
  @media screen and (min-width: 1300px) {
    display: none;
  }
`;

const PageWrapper = styled(Flex)`
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;

  @media screen and (max-width: 52em) {
    padding-left: 12px;
    padding-right: 12px;
    width: 100vw;
    max-width: 100vw;
  }
`;

const Container = styled(Flex)`
  width: 100%;

  @media screen and (max-width: 480px) {
    width: 100vw;
    max-width: 100vw;
    padding: 0 20px;
  }
`;

const MobileOnly = styled(Flex)`
  display: none;

  @media screen and (max-width: 52em) {
    display: flex;
  }
`;

const DesktopOnly = styled(Flex)`
  display: none;

  @media screen and (min-width: 52em) {
    display: flex;
  }
`;

const Chevron = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
      <path
        d="M0.182368 1.08947C0.124114 1.02782 0.0785724 0.955305 0.0483433 0.876059C0.0181142 0.796812 0.00378949 0.712387 0.00618787 0.627604C0.00858624 0.542822 0.0276605 0.459342 0.0623212 0.381931C0.0969819 0.304519 0.14655 0.234693 0.208197 0.176439C0.269843 0.118184 0.34236 0.0726425 0.421607 0.0424134C0.500854 0.0121843 0.585278 -0.00214009 0.670061 0.000258284C0.754843 0.00265666 0.838324 0.0217307 0.915735 0.0563914C0.993146 0.0910522 1.06297 0.140621 1.12123 0.202267L6.60973 6.01363C6.72308 6.13352 6.78623 6.29224 6.78623 6.45723C6.78623 6.62221 6.72308 6.78094 6.60973 6.90083L1.12123 12.7128C1.06336 12.7758 0.993546 12.8267 0.91585 12.8625C0.838154 12.8983 0.754122 12.9183 0.668634 12.9213C0.583146 12.9243 0.497906 12.9104 0.417866 12.8802C0.337827 12.85 0.264582 12.8042 0.202387 12.7455C0.140192 12.6868 0.0902868 12.6163 0.0555696 12.5381C0.0208524 12.4599 0.00201561 12.3756 0.000153087 12.2901C-0.00170943 12.2045 0.0134393 12.1195 0.0447199 12.0399C0.0760006 11.9603 0.122789 11.8877 0.182368 11.8263L5.25246 6.45723L0.182368 1.08947Z"
        fill="white"
      />
    </svg>
  );
};

const TopWarnsActions = ({ text }) => {
  return (
    <>
      <MobileOnly justifyContent={'flex-end'}>
        <Chevron />
      </MobileOnly>
      <DesktopOnly>
        <Button variant="dim" style={{ height: '46px' }}>
          {text || 'Complete'}
        </Button>
      </DesktopOnly>
    </>
  );
};

const ProgressBard = ({ pct, endDate }) => {
  return (
    <Flex flexDirection={'column'} style={{ paddingRight: '20px' }}>
      <Flex style={{ width: '100%' }} mb={'3px'}>
        <Flex flex={pct / 100} />
        <Flex flexDirection={'column'} alignItems={'center'}>
          <Flex style={{ width: '38px', height: '28px', borderRadius: '10px', background: '#354E79' }} justifyContent={'center'} alignItems={'center'}>
            <Text style={{ color: 'white', fontSize: '10px' }}>{Math.round(pct)}%</Text>
          </Flex>
          <svg style={{ marginTop: '-2px', marginLeft: '-2px' }} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.333344 1H7.66668L4.00001 7.33333" fill="#354E79" />
          </svg>
        </Flex>
        <Flex flex={1 - pct / 100} />
      </Flex>
      <Flex style={{ width: '100%', padding: '0 23px' }}>
        <Flex style={{ borderRadius: '10px', width: '100%', height: '6px', background: '#FFE3D8' }}>
          <Flex style={{ borderRadius: '10px', background: '#354E79', height: '6px' }} flex={pct / 100} />
          <Flex style={{ width: '10px', height: '10px', marginLeft: '-10px', marginRight: '-10px', border: '2px solid #354E79', background: '#FFE3D8', borderRadius: '10px', marginTop: '-2px' }} />
          <Flex style={{ borderRadius: '10px', background: 'transparent', height: '6px' }} flex={1 - pct / 100} />
        </Flex>
      </Flex>
      <Text style={{ fontSize: '10px', textAlign: 'right', marginRight: '23px' }} mt={1}>
        ends on {moment.unix(endDate).format('MM/DD/YYYY')}
      </Text>
    </Flex>
  );
};

const Landing = ({ history, session, toastManager }) => {
  return (
    <Query query={APPOINTMENTS_NUTRITIONIST} fetchPolicy={'network-only'}>
      {({ data: dataNut, loading: loadingNut }) => {
        return (
          <Query query={GET_GI_MEMBERSHIP_SUMMARY} fetchPolicy={'network-only'}>
            {({ data: giMembershipSummaryData, loading: giMembershipSummaryLoading }) => {
              if (!!giMembershipSummaryLoading) return null;
              return (
                <LandingInner
                  history={history}
                  session={session}
                  loadingAppointments={loadingNut}
                  toastManager={toastManager}
                  dataNutritionists={dataNut}
                  giMembershipSummaryData={giMembershipSummaryData}
                  giMembershipSummaryLoading={giMembershipSummaryLoading}
                />
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

const LandingInner = ({ history, loadingAppointments, dataNutritionists, giMembershipSummaryLoading, giMembershipSummaryData }) => {
  const [showPriceIncreaseModal, setShowPriceIncreaseModal] = useState(false);
  const [hasFutureAppointmentsNutritionist, setHasFutureAppointmentsNutritionist] = useState();
  const [hasPastAppointmentsNutritionist, setHasPastAppointmentsNutritionist] = useState();
  const [readyToStartApptNutritionist, setReadyToStartApptNutritionist] = useState();

  useEffect(
    () => {
      if (!!loadingAppointments) return;

      if (dataNutritionists && dataNutritionists.appointmentsNutritionist) {
        const { appointmentsNutritionist } = dataNutritionists;
        const hasAppointments = appointmentsNutritionist && appointmentsNutritionist.length > 0;
        if (hasAppointments) {
          const upcomings = appointmentsNutritionist
            .filter((item) => {
              if (item.status && item.status === 'f') {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
            .sort((a, b) => {
              const ma = moment(`${a.date} ${a.startTime}`, 'MM/DD/YYYY HH:mm');
              const mb = moment(`${b.date} ${b.startTime}`, 'MM/DD/YYYY HH:mm');
              if (ma.isBefore(mb)) return -1;
              return 1;
            });
          if (upcomings) {
            setReadyToStartApptNutritionist(
              upcomings.find((x) => {
                const ma = momentTz(`${x.date} ${x.startTime}`, 'MM/DD/YYYY HH:mm').tz(x.timezoneName);
                return ma.isBefore(
                  momentTz()
                    .tz(x.timezoneName)
                    .add(30, 'minutes')
                );
              })
            );
          }
          setHasFutureAppointmentsNutritionist(
            upcomings.find((item) => {
              if (item.status && item.status === 'f' && !isAsyncAppointment(item.appointmentTypeId)) {
                const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
                return dt.isAfter(
                  momentTz()
                    .tz(item.timezoneName)
                    .add(-120, 'minutes'),
                  'minute'
                );
              }
              return false;
            })
          );
          let past = appointmentsNutritionist.filter((item) => {
            if (item.status && (item.status === '2' || item.status === '3' || item.status === '4')) {
              const dt = momentTz(`${item.date} ${item.startTime}`, 'MM/DD/YYYY HH:mm').tz(item.timezoneName);
              return dt.isAfter(
                momentTz()
                  .tz(item.timezoneName)
                  .add(-120, 'minutes'),
                'minute'
              );
            }
            return false;
          });
          setHasPastAppointmentsNutritionist(past);
        }
      }
    },
    [dataNutritionists, loadingAppointments]
  );

  return (
    <PageWrapper flexDirection="row" pt="28px" style={{ marginBottom: '72px' }}>
      <Flex flex={1} flexDirection="column">
        <Heading mb={4}>Your GI Reset Program</Heading>
        <Flex maxWidth="650px" flexDirection="column">
          <Text>You’re doing great! Here’s everything you need in one place.</Text>
          {!giMembershipSummaryLoading &&
            !!giMembershipSummaryData &&
            !!giMembershipSummaryData.getGiMembershipSummary && (
              <>
                <Text mb={3}>
                  You’re {Math.round((giMembershipSummaryData.getGiMembershipSummary.elapsedSeconds / giMembershipSummaryData.getGiMembershipSummary.totalSeconds) * 100)}% through your{' '}
                  {giMembershipSummaryData.getGiMembershipSummary.totalMonths}
                  -month GI Reset Program.
                </Text>

                <ProgressBard
                  // pct={98}
                  endDate={giMembershipSummaryData.getGiMembershipSummary.endDate}
                  pct={(giMembershipSummaryData.getGiMembershipSummary.elapsedSeconds / giMembershipSummaryData.getGiMembershipSummary.totalSeconds) * 100}
                />
              </>
            )}
            
          {!!readyToStartApptNutritionist && (
            <Container>
              <Card
                style={{ width: '100%', maxWidth: '700px', backgroundColor: '#344F7A', borderRadius: '10px' }}
                mb={'32px'}
                onClick={() => history.push(`/visio-nutritionist/${readyToStartApptNutritionist.provider.id}`)}
              >
                <Flex style={{ overflow: 'hidden', padding: '8px 12px', justifyContent: 'center', alignItems: 'center' }}>
                  <img src={Paymentinformation} style={{ height: '68px', width: '68px', objectFit: 'contain' }} />
                  <Text color="white" fontSize={'14px'} ml={2} flex={1}>
                    Your nutritionist visit is about to start
                  </Text>

                  <TopWarnsActions text={'Start Visit'} />
                </Flex>
              </Card>
            </Container>
          )}
          {(!!loadingAppointments || hasFutureAppointmentsNutritionist) && (
            <UpcomingVisitLabs loadingAppointments={loadingAppointments} hasFutureAppointmentsNutritionist={hasFutureAppointmentsNutritionist} />
          )}

          <BoxRightMobile>
            <ToDo canFullscript={!!hasPastAppointmentsNutritionist && hasPastAppointmentsNutritionist.length > 0} canChat />
          </BoxRightMobile>

          <ServicesAvailable
            hasFutureAppointmentsNutritionist={hasFutureAppointmentsNutritionist}
            loadingAppointments={loadingAppointments}
          />

          {!!hasPastAppointmentsNutritionist &&
            hasPastAppointmentsNutritionist.length > 0 && (
              <>
                <Heading mt={4}>Your Treatment Plan</Heading>
                <CardWrap
                  alignItems="center"
                  mt={'22px'}
                  onClick={() => {
                    window.open('https://us.fullscript.com/login', '_blank');
                  }}
                >
                  <DetailsWrap>
                    <Flex flexDirection={'column'}>
                      <Text fontWeight={300} fontSize={'14px'}>
                        Your treatment plan lives on Fullscript.
                      </Text>
                      <Text fontWeight={300} fontSize={'14px'} style={{ color: '#1E5BD4', textDecoration: 'underline' }}>
                        {'View >>'}
                      </Text>
                    </Flex>
                  </DetailsWrap>
                  <CardMain style={{ cursor: 'pointer', zIndex: 1 }} className={'canClick'}>
                    <Flex alignItems={'center'} style={{ height: '100%' }}>
                      <img alt="" src={fullscriptIcon} style={{ marginRight: '10px' }} width={'58px'} />
                      <Flex flexDirection={'column'} justifyContent="center">
                        <Flex alignItems={'center'}>
                          <Text style={{ fontWeight: 500 }}>Your treatment plan</Text>
                        </Flex>
                      </Flex>
                    </Flex>
                  </CardMain>
                </CardWrap>

                <PastNutritionistVisits pastAppointments={hasPastAppointmentsNutritionist} loadingAppointments={{ loadingAppointments }} />
              </>
            )}

          <Articles category={`#Gut Health`} sectionTitle={'Resources'} />
        </Flex>
      </Flex>

      <BoxRight>
        <Flex style={{ position: 'fixed' }} flexDirection={'column'}>
          <ToDo canFullscript={!!hasPastAppointmentsNutritionist && hasPastAppointmentsNutritionist.length > 0} canChat />
        </Flex>
      </BoxRight>
      <Modal isOpen={showPriceIncreaseModal} onBackgroundClick={() => setShowPriceIncreaseModal(false)} onEscapeKeydown={() => setShowPriceIncreaseModal(false)}>
        {/* <SpecialModalBackground> */}
        <Box
          style={{
            margin: '0 auto',
            alignSelf: 'center',
            borderRadius: '20px',
            position: 'relative',
            backgroundColor: 'white',
            padding: '24px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100vw',
            maxWidth: '650px',
          }}
        >
          <Flex flexDirection={'column'}>
            <Text textAlign={'center'} fontSize={'20px'} fontWeight={600}>
              Upcoming Price Change for Visits at Paloma Health
            </Text>
            <Text textAlign={'center'} fontSize={'16px'} mt={4}>
              Starting <span style={{ textDecoration: 'underline' }}>November 15th, 2023</span>, the price for a visit at Paloma Health will be increased from $42 to $60. Our commitment to your health
              and well-being remains our top priority. The price change is a step to ensure we can continue delivering the amazing services you’ve come to expect from Paloma Health. We deeply value
              our relationship with you, and we always strive to provide you with the best care possible.
              <br />
              <br />
              To show our appreciation for your continued trust and loyalty, we have an arrangement in place for our existing members. Any visits that you book before November 15th, even if the actual
              visit date is after this date, will still be charged at the current rate of $42. This gives you the flexibility to schedule future visits at the current price if you wish to do so.
            </Text>
            <Button variant={'primary'} mt={4} alignSelf={'center'} onClick={() => setShowPriceIncreaseModal(false)}>
              OK
            </Button>
          </Flex>
        </Box>
        {/* </SpecialModalBackground> */}
      </Modal>
    </PageWrapper>
  );
};

export default withToastManager(withSession(Landing));
